import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Prn } from "../../models/prn-model/prn-model";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class PrnService {
  constructor(private http: HttpClient, private config: ConfigurationService) {}

  getPrnData(patientId: number, date: string): Observable<Prn[]> {
    return this.http.get<Prn[]>(
      `${
        this.config.getConfig().apiUrl
      }/prn-count/patient/${patientId}?date=${date}`
    );
  }

  getPrnDataByPatientRoleAndDate(
    patientId: number,
    roleCode: string,
    date: string
  ): Observable<Prn[]> {
    return this.http.get<Prn[]>(
      `${
        this.config.getConfig().apiUrl
      }/prn-count/patient/${patientId}?roleCode=${roleCode}&date=${date}`
    );
  }

  uploadOfflineAssessment(assessmentId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("assessmentId", assessmentId.toString());
    return this.http.post<any>(
      `${this.config.getConfig().apiUrl}/visits/fromPdf`,
      formData
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/prn-service/prn-service.ts